export const personalityArticles = [
  {
    id: 1,
    titles: {
      en: "Warning Signs for Suicide: Theory, Research, and Clinical Applications",
      it: "Segnali di Allarme per il Suicidio: Teoria, Ricerca e Applicazioni Cliniche"
    },
    authors: ["M. David Rudd", "Alan L. Berman", "Thomas E. Joiner Jr."],
    descriptions: {
      en: "This comprehensive guide examines the theoretical foundations, empirical research, and clinical applications of suicide warning signs, providing essential knowledge for mental health professionals in risk assessment and intervention strategies.",
      it: "Questa guida completa esamina le basi teoriche, la ricerca empirica e le applicazioni cliniche dei segnali di allarme per il suicidio, fornendo conoscenze essenziali per i professionisti della salute mentale nella valutazione del rischio e nelle strategie di intervento."
    },
    publishDate: "2024-01-15",
    availableLanguages: ['en', 'it'],
    resources: {
      en: {
        blogpost: "https://www.videotopage.com/p/4d6d0b41-a63a-4784-aa94-65fa28e042b9/introduction-to-suicide-warning-signs",
        mindmap: "https://whimsical.com/suicide-warning-signs-rudd-joiner-et-al-XmLWaLnGW2Kd6eUn9BqZQ8",
        podcast: "https://embed.disctopia.com/podcast/Y29zbW9fZWR1Y2F0aW9uLzAvMC8xLzEvMS8wMDowMDowMC80ODgzNjIwLzE="
      },
      it: {
        blogpost: "https://www.videotopage.com/p/066a8123-13d1-43f6-a066-e86d708ab89f/introduzione-scienza-segnali-allarme-prevenzione-suicidio",
        mindmap: "https://whimsical.com/segnali-di-allarme-per-il-suicidio-QSwWP9qeBBPSteocoJQ4Pr",
        podcast: "https://embed.disctopia.com/podcast/Y29zbW9fZWR1Y2F0aW9uX2l0YWxpYS8wLzAvMS8xLzEvMDA6MDA6MDAvNTEwNDE5MC8x"
      }
    }
  },
  {
    id: 2,
    titles: {
      en: "The Interpersonal Theory of Suicide",
      it: "La Teoria Interpersonale del Suicidio"
    },
    authors: ["Thomas E. Joiner, Jr.", "Kimberly A. Van Orden", "Tracy K. Witte", "M. David Rudd"],
    descriptions: {
      en: "An in-depth exploration of Joiner's interpersonal theory of suicide, examining the constructs of thwarted belongingness, perceived burdensomeness, and acquired capability for suicide as risk factors.",
      it: "Un'esplorazione approfondita della teoria interpersonale del suicidio di Joiner, esaminando i costrutti di appartenenza ostacolata, peso percepito e capacità acquisita per il suicidio come fattori di rischio."
    },
    publishDate: "2024-02-20",
    availableLanguages: ['en', 'it'],
    resources: {
      en: {
        blogpost: "https://www.videotopage.com/p/faef2c77-e83a-4f41-86f6-e7df531e1d49/introduction-interpersonal-theory-suicide",
        mindmap: "https://whimsical.com/interpersonal-theory-of-suicide-G3gH96mSCgykaFxarthutb",
        podcast: "https://embed.disctopia.com/podcast/Y29zbW9fZWR1Y2F0aW9uLzAvMC8xLzEvMS8wMDowMDowMC80ODgzNjE1LzE="
      },
      it: {
        blogpost: "https://www.videotopage.com/p/93d78ba8-4727-455a-961e-e8d8e4dcc956/introduzione-teoria-interpersonale-suicidio",
        mindmap: "https://whimsical.com/teoria-interpersonale-del-suicidio-VZS5oz7hPpNAH6ugumcuSa",
        podcast: "https://embed.disctopia.com/podcast/Y29zbW9fZWR1Y2F0aW9uX2l0YWxpYS8wLzAvMS8xLzEvMDA6MDA6MDAvNTA5NTMxNC8x"
      }
    }
  },
  {
    id: 3,
    titles: {
      en: "Interpersonal Core of Psychopathology",
      it: "Nucleo Interpersonale della Psicopatologia"
    },
    authors: ["Christopher J. Hopwood", "Aidan G.C. Wright", "Emily B. Ansell", "Aaron L. Pincus"],
    descriptions: {
      en: "This article explores the interpersonal foundations of psychopathology, examining how relational patterns and interpersonal functioning contribute to various forms of psychological distress and personality disorders.",
      it: "Questo articolo esplora le basi interpersonali della psicopatologia, esaminando come i modelli relazionali e il funzionamento interpersonale contribuiscano a varie forme di disagio psicologico e disturbi di personalità."
    },
    publishDate: "2024-03-10",
    availableLanguages: ['en', 'it'],
    resources: {
      en: {
        blogpost: "https://www.videotopage.com/p/50549402-ad64-40aa-999a-0ca7970a9fea/introduction-personality-pathology-dsm-evolution",
        mindmap: "https://whimsical.com/interpersonal-core-of-personality-pathology-3jGUWZ5TiJ5UD5tB2vCKYF",
        podcast: "https://embed.disctopia.com/podcast/Y29zbW9fZWR1Y2F0aW9uLzEvMC8wLzEvMS8wMDowMDowMC80NzU4OTE3LzE="
      },
      it: {
        blogpost: "https://www.videotopage.com/p/e8906720-885a-4bfb-8f76-13c264594ff8/introduzione-patologia-personalita",
        mindmap: "https://whimsical.com/nucleo-interpersonale-nei-disturbi-di-personalita-VQdnpGk741ZqAAiJespHsN",
        podcast: "https://embed.disctopia.com/podcast/Y29zbW9fZWR1Y2F0aW9uX2l0YWxpYS8wLzAvMS8xLzEvMDA6MDA6MDAvNTEwNDI1My8x"
      }
    }
  },
  {
    id: 4,
    titles: {
      en: "Integrating the Hierarchical Taxonomy of Psychopathology (HiTOP) into Clinical Practice",
      it: "Integrare la Tassonomia Gerarchica della Psicopatologia (HiTOP) nella Pratica Clinica"
    },
    authors: ["Camilo J. Ruggero", "Roman Kotov", "Christopher J. Hopwood", "Michael First", "Lee Anna Clark", "et al."],
    descriptions: {
      en: "A comprehensive guide for clinicians on implementing the HiTOP model in practice, providing frameworks for dimensional assessment and treatment planning based on hierarchical psychopathology structures.",
      it: "Una guida completa per i clinici sull'implementazione del modello HiTOP nella pratica, fornendo quadri per la valutazione dimensionale e la pianificazione del trattamento basati su strutture gerarchiche della psicopatologia."
    },
    publishDate: "2024-04-05",
    availableLanguages: ['en', 'it'],
    resources: {
      en: {
        blogpost: "https://www.videotopage.com/p/6a404002-7105-47a0-87dc-9d5a93a1cf17/introduction-hitop-limitations-traditional-diagnostic-systems",
        mindmap: "https://whimsical.com/9TZSxVxfit76pXMuK46csK",
        podcast: "https://embed.disctopia.com/podcast/Y29zbW9fZWR1Y2F0aW9uLzAvMC8xLzEvMC8wMDowMDowMC80ODQxMTQwLzE="
      },
      it: {
        blogpost: "https://www.videotopage.com/p/797de6bf-9dc6-4c3b-9255-38e42bde31b7/introduzione-tassonomia-gerarchica-psicopatologia",
        mindmap: "https://whimsical.com/tassonomia-hitop-nella-pratica-clinica-ED9WwzbjSgFEASjTU1sWVC",
        podcast: "https://embed.disctopia.com/podcast/Y29zbW9fZWR1Y2F0aW9uX2l0YWxpYS8wLzAvMS8xLzEvMDA6MDA6MDAvNTEwNzE3Ni8x"
      }
    }
  },
  {
    id: 28,
    titles: {
      en: "The Clinical Sense of MMPI-2 Scales by Alex Caldwell",
      it: "Il senso clinico delle scale del MMPI-2 di Alex Caldwell"
    },
    authors: ["Alex Caldwell"],
    descriptions: {
      en: "An in-depth exploration of the clinical sense of MMPI-2 scales according to Alex Caldwell's approach, offering practical insights for the interpretation and clinical use of this personality assessment instrument.",
      it: "Un'esplorazione approfondita del senso clinico delle scale del MMPI-2 secondo l'approccio di Alex Caldwell, offrendo intuizioni pratiche per l'interpretazione e l'uso clinico di questo strumento di valutazione della personalità."
    },
    publishDate: "2024-06-10",
    availableLanguages: ['en', 'it'],
    resources: {
      en: {
        blogpost: "https://www.videotopage.com/p/cf4896e3-8e23-4c5b-878d-45e060f55f29/introduction-caldwell-mmpi",
        mindmap: "https://whimsical.com/caldwell-mmpi-USypV3iCnmkrrgLVs21Cw3",
        podcast: "https://embed.disctopia.com/podcast/Y29zbW9fZWR1Y2F0aW9uLzEvMC8xLzEvMS8wMDowMDowMC81MzIyODg1LzE="
      },
      it: {
        blogpost: "https://www.videotopage.com/p/28c4de89-ce1d-47d2-83de-29a2d3e2c8d9/introduzione-ipotesi-caldwell",
        mindmap: "https://whimsical.com/caldwell-scale-mmpi-VJimJrFmw4Q5WWJGjkAs45",
        podcast: "https://embed.disctopia.com/podcast/Y29zbW9fZWR1Y2F0aW9uX2l0YWxpYS8xLzAvMS8xLzEvMDA6MDA6MDAvNTI3NDkxMy8x"
      }
    }
  },
  {
    id: 29,
    titles: {
      en: "When and How Assessment Matters: An Update on the Treatment Utility of Clinical Assessment",
      it: "Utilità Terapeutica della valutazione clinica"
    },
    authors: ["Jan H. Kamphuis", "Arjen Noordhof", "Christopher J. Hopwood"],
    descriptions: {
      en: "An analysis of the therapeutic utility of clinical assessment, exploring how assessment tools can be effectively integrated into the therapeutic process to improve treatment outcomes.",
      it: "Un'analisi dell'utilità terapeutica della valutazione clinica, esplorando come gli strumenti di assessment possano essere integrati efficacemente nel processo terapeutico per migliorare i risultati del trattamento."
    },
    publishDate: "2024-06-15",
    availableLanguages: ['en', 'it'],
    resources: {
      en: {
        blogpost: "https://www.videotopage.com/p/200b6adc-40ef-45a6-8eb0-a164a1482574/introduction-to-clinical-evaluation",
        mindmap: "https://whimsical.com/generated-board-AnzfAgLfnTX4sJ4R9dSHRH",
        podcast: "https://embed.disctopia.com/podcast/Y29zbW9fZWR1Y2F0aW9uLzEvMC8xLzEvMS8wMDowMDowMC81MzIyODk5LzE="
      },
      it: {
        blogpost: "https://www.videotopage.com/p/6d0982ad-f0b3-4675-9508-06d9816de7a5/introduzione-valutazione-clinica-psicoterapia",
        mindmap: "https://whimsical.com/generated-board-42YTsgttsm141MM5Hgjoqv",
        podcast: "https://embed.disctopia.com/podcast/Y29zbW9fZWR1Y2F0aW9uX2l0YWxpYS8xLzAvMS8xLzEvMDA6MDA6MDAvNTMxOTQ0OC8x"
      }
    }
  },
  {
    id: 33,
    titles: {
      en: "Making Sense of Diagnosis: The Psychodynamic Diagnostic Manual and the Shedler-Westen Assessment Procedure-200",
      it: "Dare un senso alla diagnosi: il Manuale Diagnostico Psicodinamico e la Shedler Westen Assessment Procedure duecento"
    },
    authors: ["Vittorio Lingiardi"],
    descriptions: {
      en: "An exploration of the Psychodynamic Diagnostic Manual (PDM) and the Shedler-Westen Assessment Procedure-200 (SWAP-200), examining how these comprehensive diagnostic frameworks integrate personality functioning, mental functioning, and symptom patterns to provide a richer understanding of psychological complexity beyond traditional categorical diagnosis.",
      it: "Un'esplorazione del Manuale Diagnostico Psicodinamico (PDM) e della Shedler-Westen Assessment Procedure-200 (SWAP-200), esaminando come questi framework diagnostici completi integrino il funzionamento della personalità, il funzionamento mentale e i pattern sintomatici per fornire una comprensione più ricca della complessità psicologica oltre la diagnosi categoriale tradizionale."
    },
    publishDate: "2024-07-05",
    availableLanguages: ['en', 'it'],
    resources: {
      en: {
        blogpost: "https://www.videotopage.com/p/28e7ac4a-17d3-40ef-945b-f3c3a12fd079/complessita-diagnosi-psicologia-clinica",
        mindmap: "https://whimsical.com/making-sense-of-diagnosis-4jA86CFa9i5K2TctVzwpRW",
        podcast: "https://embed.disctopia.com/podcast/Y29zbW9fZWR1Y2F0aW9uLzEvMC8xLzEvMS8wMDowMDowMC81NDA0OTM4LzE="
      },
      it: {
        blogpost: "https://www.videotopage.com/p/28e7ac4a-17d3-40ef-945b-f3c3a12fd079/complessita-diagnosi-psicologia-clinica",
        mindmap: "https://whimsical.com/dare-un-senso-alla-diagnosi-E9NwjwP9pESPKhsdhraxHh",
        podcast: "https://embed.disctopia.com/podcast/Y29zbW9fZWR1Y2F0aW9uX2l0YWxpYS8xLzAvMS8xLzEvMDA6MDA6MDAvNTQwNDg5Ny8x"
      }
    }
  },
  {
    id: 36,
    titles: {
      en: "Assessing Interpersonal Style and Personality Functioning through the Picture Frustration Study: A Pilot Study on the COSMO Collaborative Coding System",
      it: "Valutare lo stile interpersonale e il funzionamento della personalità attraverso il Picture Frustration Study: uno studio pilota sul sistema di codifica collaborativo COSMO"
    },
    authors: ["Filippo Aschieri", "Emanuela Brusadelli", "Gianfranco Di Gennaro", "Silvia Salcuni", "Carlo Vetere"],
    descriptions: {
      en: "A pilot study evaluating the effectiveness of the COSMO collaborative coding system in assessing interpersonal style and personality functioning through the Picture Frustration Study.",
      it: "Uno studio pilota che valuta l'efficacia del sistema di codifica collaborativo COSMO nella valutazione dello stile interpersonale e del funzionamento della personalità attraverso il Picture Frustration Study."
    },
    publishDate: "2024-07-20",
    availableLanguages: ['en', 'it'],
    resources: {
      en: {
        blogpost: "https://www.videotopage.com/p/8cb586cf-d2df-4967-9722-ea4221213d84/introduction-cosmo-picture-frustration",
        mindmap: "https://whimsical.com/carlo-s-workspace765/cosmo-collaborative-coding-system-english-mind-map-LN6gj4iqVZ4H6TxFdj3jzC",
        podcast: "https://embed.disctopia.com/podcast/Y29zbW9fZWR1Y2F0aW9uLzEvMC8xLzEvMS8wMDowMDowMC81NTE5MDgwLzE="
      },
      it: {
        blogpost: "https://www.videotopage.com/p/54fef6da-f8ab-4f3b-b524-83f119314836/introduzione-cosmo-picture-frustration",
        mindmap: "https://whimsical.com/carlo-s-workspace765/cosmo-collaborative-coding-system-mind-map-EG8GeXfYvSkJk7W4FtXVmB",
        podcast: "https://embed.disctopia.com/podcast/Y29zbW9fZWR1Y2F0aW9uX2l0YWxpYS8xLzAvMS8xLzEvMDA6MDA6MDAvNTUxOTA4Mi8x"
      }
    }
  }
];